<template>
  <div>
    <h3 style="margin-left: 30px;">
      Сборщики
    </h3>
  </div>
</template>

<script>
/**
 * Корновой Vue компонент страницы сборщиков
 * @module PagePickers/Component/App
 */
export default {
  name: 'PagePickers'
}
</script>

<style lang="scss" scoped>
#content {
  width: 100%;
}
</style>
